import { ChangeEvent } from "react";
import { Condicao } from "../../../../types/Parcelamento";

interface FixedConditionProps {
  qtdDias: string;
  changeParcelamento: (value: string) => void;
  condicoes: Condicao[];
  codigoParcelamentoEspecial?: string | number | undefined;
  useEspecialConditions: boolean;
  disabled?: boolean;
}

function FixedCondition({
  qtdDias,
  changeParcelamento,
  condicoes,
  codigoParcelamentoEspecial,
  useEspecialConditions,
  disabled = false,
}: FixedConditionProps) {
  return (
    <select
      name="parcelamento"
      value={codigoParcelamentoEspecial || qtdDias || ""}
      onChange={(event: ChangeEvent<HTMLSelectElement>) => {
        changeParcelamento(event.target.value);
      }}
      disabled={disabled || !useEspecialConditions}
    >
      <option value="">Selecione</option>
      {condicoes.map(condicao => (
        <option key={condicao.cdParcela} value={condicao.cdParcela}>
          {condicao.description}
        </option>
      ))}
    </select>
  );
}

export default FixedCondition;
